import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";

// شارة «عن بُعد» بجانب اسم الموظف مع تاريخ بدء السريان (منذ/من) لتسهيل متابعة المدير.
export const RemoteBadge = ({ workMode, since }) => {
  const { t } = useTranslation();
  if (workMode !== "remote") return null;
  const today = new Date().toISOString().slice(0, 10);
  const label = !since
    ? t("employees.remoteBadge")
    : today >= since
      ? t("employees.remoteSince", { date: since })
      : t("employees.remoteFrom", { date: since });
  return (
    <span data-testid="remote-badge"
      className="inline-flex items-center gap-1 rounded-full bg-sky-500/10 px-2.5 py-0.5 text-[11px] font-bold text-sky-600">
      <Home className="h-3 w-3" /> {label}
    </span>
  );
};
